import { Link } from 'gatsby';
import React from 'react';
import tw from 'twin.macro';

const Container = tw(
  Link,
)`flex items-center justify-center mx-auto my-8 py-4 max-w-sm bg-gradient-to-br from-indigo-100 to-purple-50 text-sm`;
const IndicatorContainer = tw.div`flex w-2 h-2 mx-2`;
const Indicator = tw.div`relative inline-flex w-2 h-2 rounded-full bg-green-500`;
const IndicatorBg = tw.div`animate-ping absolute inline-flex w-2 h-2 rounded-full bg-green-400 opacity-75`;
const Name = tw.span`ml-1 font-semibold`;

const ServiceStatus = () => {
  return (
    <Container to="/consult">
      我们的状态：
      <IndicatorContainer>
        <IndicatorBg />
        <Indicator />
      </IndicatorContainer>
      <Name>→ 营业中 ←</Name>
    </Container>
  );
};

export default ServiceStatus;
